import { Accessibility, Co2, SpaOutlined } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';

import { Fonts } from '@/ui/theme/fonts';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

export function PdfScoreCard({
  type,
  scoreLetter,
  size = 'large',
}: {
  type: 'co2' | 'env' | 'ess';
  scoreLetter: string;
  size?: 'medium' | 'large';
}) {
  const scoreIcon: React.ReactNode = {
    co2: <Co2 />,
    env: <SpaOutlined />,
    ess: <Accessibility />,
  }[type];

  const scoreTextColor = getColorForScore(scoreLetter).text;
  const scoreBackgroundColor = getColorForScore(scoreLetter).main;
  return (
    <div>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        alignItems={'start'}
      >
        <Box
          sx={{
            color: scoreTextColor,
            backgroundColor: scoreBackgroundColor,
            mt: size === 'medium' ? 0 : 0.5,
            mr: 1,
            minWidth: size === 'medium' ? 50 : 70,
            px: 1.6,
            paddingTop: 0.9,
            paddingBottom: 1.1,
            width: 'fit-content',
            height: size === 'medium' ? 42 : 50,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '10px',
            fontSize: size === 'medium' ? 20 : 22,
            fontWeight: '900',
            fontFamily: Fonts.DarkerGrotesque,
            '& svg': {
              mr: 1,
              mt: 0.5,
            },
          }}
        >
          {scoreIcon}
          {scoreLetter}
        </Box>
      </Stack>
    </div>
  );
}
